import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    width: '100%',
    overflow: 'hidden'
  },
  root: {
    display: 'flex',
    height: '100%',
    width: '100%',
    overflow: 'hidden'
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    overflow: 'hidden'
  },
  pageContainer: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    overflow: 'auto',
    // Stop iOS Safari's rubber-band/overscroll from revealing blank space
    // above the content (e.g. above the Orders/Backorders tabs) when scrolling.
    overscrollBehavior: 'contain',
    WebkitOverflowScrolling: 'touch',
    '& *': {
      boxSizing: 'border-box'
    }
  }
}));
